import { STORAGE_KEYS } from '~constants'

const getOAuth2Params = () => {
  const metadata = localStorage.getItem(STORAGE_KEYS.OAUTH2_PARAMS)
  return metadata
}

export default getOAuth2Params
